import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { TalentService } from 'src/app/providers/talent/talent.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import Swal from 'sweetalert2';
declare let $: any;
@Component({
  selector: 'app-joining-dashboard',
  templateUrl: './joining-dashboard.component.html',
  styleUrls: ['./joining-dashboard.component.scss']
})
export class JoiningDashboardComponent implements OnInit {

  extendJoin: FormGroup;
  searchTerm: any;
  response: any = [];
  joiniesList: any = [];
  result: any = [];
  constructor(private dashboardService: DashboardService,
              private talentService: TalentService,
              private notifyService: NotificationService,
              private router: Router
              ) { }

  ngOnInit(): void {
    this.getCandList();
  }
  getCandList(): void {
    this.dashboardService.getNewJoiningList().subscribe(res => {
      this.response = res;
      this.joiniesList = this.response.data;
      console.table(this.response.data);
    },
    err => {
      console.log(err);
    });
  }
  openModal(id): void {
    $(id).modal({ backdrop: 'static', keyboard: false });
  }

  searchBy(event): void {
    this.searchTerm = event.target.value;
  }
  addEmpJoin(candID): void {
    Swal.fire({
      title: 'Are you sure, you want to confirm transfer of this employee ?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No, '
    }).then((result) => {
      if (result.value) {
        const param = { cand_id: candID };
        // this.talentService.joinCandidate(param).subscribe( res => {
        //   console.log(res);
        //   this.result = res;
        //   if (this.result.status){
        //     this.notifyService.showSuccess(this.result.msg, 'Success!');
        //     // this.getMrfCandidatesList(this.mrfId);
        //     setTimeout(() => {
        //       // enc_emp_id
        //       this.router.navigate(['/employee/employee/' + this.result.enc_emp_id + '/' + this.result.emp_id]);
        //     });
        //   }else{
        //     this.notifyService.showWarning(this.result.msg, 'Error!');

        //   }
        // },
        // err => {
        //   this.notifyService.showError('Internal server error', 'Error!');
        // });
      }else{

      }
    });
  }
  addCandJoin(candID): void {
    Swal.fire({
      title: 'Are you sure, you want to convert this candidate to employee ?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No, '
    }).then((result) => {
      if (result.value) {
        const param = { cand_id: candID };
        this.talentService.joinCandidate(param).subscribe( res => {
          console.log(res);
          this.result = res;
          if (this.result.status){
            this.notifyService.showSuccess(this.result.msg, 'Success!');
            // this.getMrfCandidatesList(this.mrfId);
            setTimeout(() => {
              // enc_emp_id
              this.router.navigate(['/employee/employee/' + this.result.enc_emp_id + '/' + this.result.emp_id]);
            });
          }else{
            this.notifyService.showWarning(this.result.msg, 'Error!');

          }
        },
        err => {
          this.notifyService.showError('Internal server error', 'Error!');
        });
      }else{

      }
    });
  }
  rejectUser(candID): void {
    Swal.fire({
      title: 'Are you sure, this candaite is rejected ?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No, '
    }).then((result) => {
      if (result.value) {
        const param = { cand_id: candID };
        this.talentService.rejectCandidate(param).subscribe( res => {
          console.log(res);
          this.result = res;
          if (this.result.status){
            this.notifyService.showSuccess(this.result.msg, 'Success!');
            this.getCandList();
            setTimeout(() => {
              // this.router.navigate(['/employee/employee/' + this.result.enc_emp_id + '/' + this.result.emp_id]);
            });
          }else{
            this.notifyService.showWarning(this.result.msg, 'Error!');

          }
        },
        err => {
          this.notifyService.showError('Internal server error', 'Error!');
        });
      }else{

      }
    });
  }
}
